import React, { useEffect, useState } from 'react';
import { Menu, X, PhoneCall } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
export function Header() {
  const {
    lang,
    setLang
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const text = t[lang];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleLang = () => {
    setLang(lang === 'en' ? 'es' : 'en');
  };
  const navLinks = [{
    name: text.nav.home,
    href: '#home'
  }, {
    name: text.nav.services,
    href: '#services'
  }, {
    name: text.nav.pricing,
    href: '#booking'
  }, {
    name: text.nav.gallery,
    href: '#gallery'
  }, {
    name: text.nav.faq,
    href: '#faq'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-mf-black shadow-lg py-2' : 'bg-mf-black/90 py-4'}`} data-id="element-305">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306">
          <div className="flex justify-between items-center" data-id="element-307">
            {/* Logo */}
            <a href="#home" className="flex-shrink-0 flex items-center" data-id="element-308">
              <img src="https://cdn.magicpatterns.com/uploads/87bxoPCzmrJpV9TJfPPsjR/IMG_4659.jpg" alt="Move Fighters Logo" className="h-12 w-auto object-contain rounded" data-id="element-309" />
            </a>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center space-x-8" data-id="element-310">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-mf-white hover:text-mf-yellow font-condensed text-lg font-bold tracking-wide transition-colors uppercase" data-id="element-311">
                  {link.name}
                </a>)}

              <button onClick={toggleLang} className="flex items-center bg-mf-darkgray hover:bg-gray-700 text-white px-3 py-1 rounded font-bold text-sm transition-colors" data-id="element-312">
                <span className={lang === 'en' ? 'text-mf-yellow' : 'text-gray-400'} data-id="element-313">
                  EN
                </span>
                <span className="mx-1" data-id="element-314">|</span>
                <span className={lang === 'es' ? 'text-mf-yellow' : 'text-gray-400'} data-id="element-315">
                  ES
                </span>
              </button>

              <a href="tel:+18134768935" className="hidden lg:flex items-center text-mf-yellow hover:text-white font-condensed font-bold text-lg tracking-wide transition-colors" data-id="element-316">
                <PhoneCall size={20} className="mr-2" data-id="element-317" />
                (813) 476-8935
              </a>

              <a href="#booking" className="bg-mf-red hover:bg-red-700 text-white px-6 py-2 rounded font-condensed font-bold text-lg uppercase tracking-wider transition-colors shadow-md" data-id="element-318">
                {text.nav.rescueMe}
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <div className="md:hidden flex items-center space-x-4" data-id="element-319">
              <button onClick={toggleLang} className="flex items-center bg-mf-darkgray text-white px-2 py-1 rounded font-bold text-xs" data-id="element-320">
                <span className={lang === 'en' ? 'text-mf-yellow' : 'text-gray-400'} data-id="element-321">
                  EN
                </span>
                <span className="mx-1" data-id="element-322">|</span>
                <span className={lang === 'es' ? 'text-mf-yellow' : 'text-gray-400'} data-id="element-323">
                  ES
                </span>
              </button>
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white hover:text-mf-yellow p-2" data-id="element-324">
                {mobileMenuOpen ? <X size={28} data-id="element-325" /> : <Menu size={28} data-id="element-326" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Nav Dropdown */}
        {mobileMenuOpen && <div className="md:hidden bg-mf-black border-t border-gray-800 absolute w-full" data-id="element-327">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-328">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-mf-white hover:text-mf-yellow font-condensed text-xl font-bold uppercase border-b border-gray-800" data-id="element-329">
                  {link.name}
                </a>)}
            </div>
          </div>}
      </header>

      {/* Mobile Floating CTA */}
      <div className="md:hidden fixed bottom-4 left-4 right-4 z-40" data-id="element-330">
        <a href="#booking" className="flex items-center justify-center w-full bg-mf-red text-white py-4 rounded-lg font-condensed font-bold text-xl uppercase tracking-wider shadow-[0_4px_14px_0_rgba(211,47,47,0.39)] hover:bg-red-700 transition-colors" data-id="element-331">
          <PhoneCall className="mr-2" size={24} data-id="element-332" />
          {text.nav.rescueMe}
        </a>
      </div>
    </>;
}